import TextField from "./TextField";
import EmailValidator from "./validators/EmailValidator";

export default class EmailField extends TextField {
    constructor(isOptional = false, initialValue = '', feature = undefined) {
        super(1, 100, isOptional, initialValue, feature);
        this._validators.push(new EmailValidator());
    }
}
